import React from 'react'
import { Chip } from '@equinor/eds-core-react'
import styled from 'styled-components'

interface ActiveFilterChipProps {
    onDelete: () => void
    children: React.ReactNode
}

const ActiveFilterChip: React.FC<ActiveFilterChipProps> = ({ onDelete, children }) => (
    <StyledChip variant="active" onDelete={onDelete}>
        {children}
    </StyledChip>
)

const StyledChip = styled(Chip)`
    && {
        background-color: #cfe7e9;
        color: #1f6369;
        border: none;
    }

    &&:hover,
    &&:focus,
    &&:focus-within,
    &&[data-state='active']:hover {
        background-color: #cfe7e9;
        color: #1f6369;
    }

    && svg {
        fill: #1f6369;
    }
`

export default ActiveFilterChip
